// extracted by mini-css-extract-plugin
export default {"footer":"CurrencyTypeSelectionModal_footer__EYZp6","body":"CurrencyTypeSelectionModal_body__B1cIl"};